// Tracking utility for Meta (Facebook) Pixel + TikTok Pixel.
// Pixel IDs are configured in the admin panel (stored in backend settings)
// and injected at runtime — no code changes or rebuild needed to add them.

let initialized = false;
let hasMeta = false;
let hasTikTok = false;

function injectMetaPixel(pixelId) {
  if (!pixelId || window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  hasMeta = true;
}

function injectTikTokPixel(pixelId) {
  if (!pixelId || window.ttq) return;
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    };
    ttq.load = function (e, n) {
      var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = i;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      var o = d.createElement("script");
      o.type = "text/javascript"; o.async = !0; o.src = i + "?sdkid=" + e + "&lib=" + t;
      var a = d.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(o, a);
    };
    ttq.load(pixelId);
    ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
  hasTikTok = true;
}

export function initPixels(settings) {
  if (initialized || !settings) return;
  initialized = true;
  try {
    injectMetaPixel(settings.metaPixelId);
    injectTikTokPixel(settings.tiktokPixelId);
    trackPageView();
  } catch (e) {
    console.error("Pixel init error:", e);
  }
}

export function trackPageView() {
  if (hasMeta && window.fbq) window.fbq("track", "PageView");
  if (hasTikTok && window.ttq) window.ttq.page();
}

export function trackViewContent(product) {
  if (!product) return;
  if (hasMeta && window.fbq)
    window.fbq("track", "ViewContent", {
      content_ids: [product.id], content_name: product.name,
      content_type: "product", value: product.price, currency: "EUR",
    });
  if (hasTikTok && window.ttq)
    window.ttq.track("ViewContent", {
      content_id: product.id, content_name: product.name,
      value: product.price, currency: "EUR",
    });
}

export function trackAddToCart(product, qty = 1) {
  if (!product) return;
  const value = (product.price || 0) * qty;
  if (hasMeta && window.fbq)
    window.fbq("track", "AddToCart", {
      content_ids: [product.id], content_name: product.name,
      content_type: "product", value, currency: "EUR",
    });
  if (hasTikTok && window.ttq)
    window.ttq.track("AddToCart", {
      content_id: product.id, content_name: product.name,
      quantity: qty, value, currency: "EUR",
    });
}

export function trackInitiateCheckout(items, total) {
  const ids = (items || []).map((i) => i.id);
  if (hasMeta && window.fbq)
    window.fbq("track", "InitiateCheckout", {
      content_ids: ids, num_items: (items || []).length,
      value: total, currency: "EUR",
    });
  if (hasTikTok && window.ttq)
    window.ttq.track("InitiateCheckout", { value: total, currency: "EUR" });
}

export function trackPurchase(orderId, value) {
  if (hasMeta && window.fbq)
    window.fbq("track", "Purchase", { value, currency: "EUR" });
  if (hasTikTok && window.ttq)
    window.ttq.track("CompletePayment", { value, currency: "EUR" });
}
